// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__rhokM","cell":"ColumnAccessor_cell__2v6lo","firstCellAccent":"ColumnAccessor_firstCellAccent__1rU6v"};